import { render, staticRenderFns } from "./AssetImageLinkShow.vue?vue&type=template&id=99ce20d0&"
import script from "./AssetImageLinkShow.vue?vue&type=script&lang=js&"
export * from "./AssetImageLinkShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports